import { useEffect } from "react";
import { Alert, CircularProgress, Stack, Typography } from "@mui/material";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import AuthPageShell from "../components/auth/AuthPageShell";
import { loginSucceeded } from "../features/auth/authSlice";
import { consumePendingOAuthFlow } from "../utils/oauthFlowGuard";

const safeReturnTo = (value) =>
  value && value.startsWith("/") && !value.startsWith("//") ? value : "/dashboard";

const OAuthCallbackPage = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { t } = useTranslation();

  useEffect(() => {
    const params = new URLSearchParams(window.location.hash.replace(/^#/, ""));
    const token = params.get("token");
    const error = params.get("error");
    const returnTo = safeReturnTo(params.get("returnTo"));

    if (token) {
      if (!consumePendingOAuthFlow()) {
        window.history.replaceState(null, "", "/oauth/callback");
        navigate("/login", {
          replace: true,
          state: { oauthError: "stale_callback" },
        });
        return;
      }

      dispatch(loginSucceeded(token));
      window.history.replaceState(null, "", "/oauth/callback");
      navigate(returnTo, { replace: true });
      return;
    }

    const timeout = window.setTimeout(() => {
      navigate("/login", {
        replace: true,
        state: { oauthError: error || "signin_failed" },
      });
    }, 1800);

    return () => window.clearTimeout(timeout);
  }, [dispatch, navigate]);

  return (
    <AuthPageShell title={t("auth.social.callbackTitle")} subtitle={t("auth.social.callbackSubtitle")}>
      <Stack spacing={2} alignItems="center">
        <CircularProgress size={28} />
        <Typography color="text.secondary">{t("auth.social.callbackWorking")}</Typography>
        <Alert severity="info">{t("auth.social.callbackFallback")}</Alert>
      </Stack>
    </AuthPageShell>
  );
};

export default OAuthCallbackPage;
